import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const translations = {
  en: null,
  fr: null,
  es: null,
  it: null,
  ru: null,
  ar: null,
  de: null
};

export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadTranslations = async () => {
      if (!translations[currentLanguage]) {
        setIsLoading(true);
        try {
          const translationModule = await import(`../translations/${currentLanguage}.json`);
          translations[currentLanguage] = translationModule.default;
        } catch (error) {
          console.error(`Failed to load translations for ${currentLanguage}:`, error);
          // Fallback to English if translation fails
          if (currentLanguage !== 'en' && !translations.en) {
            const fallbackModule = await import('../translations/en.json');
            translations.en = fallbackModule.default;
          }
        }
        setIsLoading(false);
      }
    };

    loadTranslations();
  }, [currentLanguage]);

  const t = (key, fallback = '') => {
    if (!translations[currentLanguage]) {
      return fallback || key;
    }

    const keys = key.split('.');
    let value = translations[currentLanguage];

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Try fallback to English
        if (currentLanguage !== 'en' && translations.en) {
          let fallbackValue = translations.en;
          for (const fk of keys) {
            if (fallbackValue && typeof fallbackValue === 'object' && fk in fallbackValue) {
              fallbackValue = fallbackValue[fk];
            } else {
              return fallback || key;
            }
          }
          return fallbackValue;
        }
        return fallback || key;
      }
    }

    return value || fallback || key;
  };

  return { t, isLoading, currentLanguage };
};
